import { media } from 'src/ui/common/mixins/media';
import styled from 'styled-components';

export const StyledCollectionWrapper = styled.div`
    border-bottom: 1px solid ${({ theme }) => theme.colors.gs400};
    scroll-behavior: smooth;
`;

export const StyledCollectionDesc = styled.div`
    max-width: 590px;
    margin: 0 auto 22px;
    font-family: ${({ theme }) => theme.fonts.title};
    font-size: 20px;
    line-height: 24px;
    text-align: center;

    ${media.sm`
        font-size: 25px;
        line-height: 30px;
    `}
`;

export const StyledImageWrapper = styled.div`
    & img {
        border-radius: 5px;
    }
`;

export const StyledSecondSectionTitle = styled.div`
    font-family: ${({ theme }) => theme.fonts.title};
    max-width: 624px;
    margin: 0 auto;
    font-size: 24px;
    line-height: 110%;
    text-align: center;
    padding-bottom: 25px;

    ${media.sm`
        font-size: 39px;
        line-height: 120%;
    `}
`;

export const StyledThirdSectionTitle = styled.div`
    font-family: ${({ theme }) => theme.fonts.title};
    max-width: 800px;
    margin: 0 auto;
    font-size: 24px;
    line-height: 110%;
    text-align: center;
    padding-bottom: 40px;

    ${media.sm`
        font-size: 39px;
        line-height: 120%;
    `}
`;

export const StyledGifWrapper = styled.div`
    max-width: 756px;
    margin: 0 auto;

    & img {
        border-radius: 30px;
    }
`;
